module.exports = "/public/images/logo_dashboard.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/logo_dashboard.png
// module id = 599
// module chunks = 7